import { Logout } from '@mui/icons-material'
import { Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { FC } from 'react'

import useUser from '../../../hooks/useUser'
import Button from '../Button'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../Modal'

interface SignoutModalProps {
  open: boolean
  onClose: (reason?: 'backdropClick' | 'escapeKeyDown') => void
}

const SignoutModal: FC<SignoutModalProps> = ({ open, onClose }) => {
  const { enqueueSnackbar } = useSnackbar()
  const { signout } = useUser()

  const onSignout = async () => {
    try {
      await signout()
      onClose()
      // Full reload (not history.push) so AuthGate re-reads the now-cleared
      // session token and renders the login screen. A client-side navigation
      // would keep the already-mounted authenticated tree, leaving the user in
      // the app after logout.
      window.location.assign('/')
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' })
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader icon={<Logout color="primary" />}>
        <span>Sign Out</span>
      </ModalHeader>

      <ModalBody>
        <Typography sx={{ color: 'grey.600' }}>Are you sure you want to sign out?</Typography>
      </ModalBody>

      <ModalFooter>
        <Button style={{ marginLeft: 'auto' }} variant="text" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button className="save-btn" color="primary" variant="contained" onClick={onSignout}>
          Sign out
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SignoutModal
